export const ahooksBuiltInAPI = [
  'useRequest',
  // Scene
  'useAntdTable',
  'useFusionTable',
  'useInfiniteScroll',
  'usePagination',
  'useDynamicList',
  'useVirtualList',
  'useHistoryTravel',
  'useNetwork',
  'useSelections',
  'useCountDown',
  'useCounter',
  'useTextSelection',
  'useWebSocket',
  // LifeCycle
  'useMount',
  'useUnmount',
  'useUnmountedRef',
  // State
  'useSetState',
  'useBoolean',
  'useToggle',
  'useUrlState',
  'useCookieState',
  'useLocalStorageState',
  'useSessionStorageState',
  'useDebounce',
  'useThrottle',
  'useMap',
  'useSet',
  'usePrevious',
  'useRafState',
  'useSafeState',
  'useGetState',
  'useResetState',
  // Effect
  'useUpdateEffect',
  'useUpdateLayoutEffect',
  'useAsyncEffect',
  'useDebounceEffect',
  'useDebounceFn',
  'useThrottleFn',
  'useThrottleEffect',
  'useDeepCompareEffect',
  'useDeepCompareLayoutEffect',
  'useInterval',
  'useRafInterval',
  'useTimeout',
  'useRafTimeout',
  'useLockFn',
  'useUpdate',
  // Dom
  'useEventListener',
  'useClickAway',
  'useDocumentVisibility',
  'useDrop',
  'useDrag',
  'useEventTarget',
  'useExternal',
  'useTitle',
  'useFavicon',
  'useFullscreen',
  'useHover',
  'useMutationObserver',
  'useInViewport',
  'useKeyPress',
  'useLongPress',
  'useMouse',
  'useResponsive',
  'useScroll',
  'useSize',
  'useFocusWithin',
  // Advanced
  'useControllableValue',
  'useCreation',
  'useEventEmitter',
  'useIsomorphicLayoutEffect',
  'useLatest',
  'useMemoizedFn',
  'useReactive',
  // Dev
  'useTrackedEffect',
  'useWhyDidYouUpdate'
]
